function Aboutus() {
  return (
    <div className="bg-gray-100 min-h-screen py-12">
      <div className="container mx-auto px-6 lg:px-20">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            About <span className="text-green-600">Smart Wallet Picks</span>
          </h1>
          <p className="text-lg text-gray-600">
            Discover the best credit cards tailored for savvy deal-seekers.
          </p>
        </div>

        {/* Content Section */}
        <div className="bg-white shadow-lg rounded-lg p-8 lg:p-12">
          <h2 className="text-3xl font-semibold text-gray-800 mb-6">
            Welcome to{" "}
            <span className="text-yellow-500">Smart Wallet Picks</span>
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            This site is designed to help you discover the best credit cards for
            maximizing rewards, perks, and savings.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            Here, I share my current credit card lineup and explain the main
            reasons behind each selection. From earning cashback and travel
            rewards to leveraging exclusive benefits, these cards have been
            chosen with a focus on saving money while making the most of every
            transaction.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            Whether you're looking to optimize your spending, reduce fees, or
            explore new card opportunities,
            <span className="text-blue-500"> Smart Wallet Picks</span> is here
            to provide valuable insights and recommendations tailored for savvy
            deal-seekers. Let’s help you build a smarter wallet!
          </p>
          <div className="text-center mt-8">
            <a
              href="/wallet"
              className="px-8 py-3 bg-green-600 text-white font-semibold rounded-md shadow-md hover:bg-green-700 transition duration-200"
            >
              Explore Wallet
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Aboutus
